/* Desktop nav hover-open for Dawn details menus, hash cleanup and drawer tabs (D-0345) */
(() => {
  const DESKTOP = '(min-width: 990px) and (hover: hover) and (pointer: fine)';
  const mq = window.matchMedia(DESKTOP);

  const CLOSE_DELAY = 140;

  const summaryOf = (details) => details.querySelector('summary');

  const open = (details) => {
    if (details.open) return;
    details.open = true;
    const s = summaryOf(details);
    if (s) s.setAttribute('aria-expanded', 'true');
  };

  const close = (details) => {
    if (!details.open) return;
    details.removeAttribute('open');
    const s = summaryOf(details);
    if (s) s.setAttribute('aria-expanded', 'false');
  };

  const wire = () => {
    document.querySelectorAll('.header__inline-menu header-menu').forEach((host) => {
      if (host.dataset.drbHover === 'true') return;
      host.dataset.drbHover = 'true';

      const details = host.querySelector('details');
      if (!details) return;

      let timer = null;

      /* Bound to header-menu, not summary: moving into the panel must not close it (D-0347) */
      host.addEventListener('pointerenter', (event) => {
        if (!mq.matches || event.pointerType === 'touch') return;
        window.clearTimeout(timer);
        open(details);
      });

      host.addEventListener('pointerleave', (event) => {
        if (!mq.matches || event.pointerType === 'touch') return;
        window.clearTimeout(timer);
        timer = window.setTimeout(() => close(details), CLOSE_DELAY);
      });

      /* detail 0 is keyboard Enter or Space; keep the check or keyboards cannot open (D-0348) */
      details.addEventListener('click', (event) => {
        if (!mq.matches) return;
        if (event.detail === 0) return;
        if (!event.target.closest('summary')) return;
        event.preventDefault();
      });
    });
  };

  const onChange = () => {
    if (mq.matches) return;
    document.querySelectorAll('.header__inline-menu header-menu details[open]').forEach(close);
  };

  if (mq.addEventListener) mq.addEventListener('change', onChange);
  else if (mq.addListener) mq.addListener(onChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire, { once: true });
  } else {
    wire();
  }

  document.addEventListener('shopify:section:load', wire);
})();

/* Hash removed 900ms after the jump: earlier replace cancels smooth scroll (D-0350) */
(() => {
  const strip = () => {
    if (!window.location.hash) return;
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  };

  if (window.location.hash) window.setTimeout(strip, 900);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#"]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (href === '#' || href.indexOf('#') < 0) return;
    if (link.origin !== window.location.origin) return;
    if (link.pathname !== window.location.pathname) return;

    window.setTimeout(strip, 900);
  });
})();

(() => {
  document.querySelectorAll('[data-drb-drawer]').forEach((root) => {
    if (root.dataset.drbReady === 'true') return;
    root.dataset.drbReady = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-drb-drawer-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-drb-drawer-panel]'));
    if (tabs.length < 2) return;

    const gauge = (p) => {
      if (p.hidden) return;
      const edge = p.getBoundingClientRect().bottom;
      const rows = p.querySelectorAll('.drb-panel__row:not(.drb-drawer__feature), .drb-panel__grouprow');
      let buried = 0;
      rows.forEach((r) => {
        if (r.getBoundingClientRect().top >= edge - 8) buried += 1;
      });
      const over = buried > 0;
      p.classList.toggle('is-scrollable', over);
      p.classList.toggle('is-end', over && p.scrollTop + p.clientHeight >= p.scrollHeight - 12);
    };

    panels.forEach((p) => {
      if (p.dataset.drbGauged === 'true') return;
      p.dataset.drbGauged = 'true';
      p.addEventListener('scroll', () => gauge(p), { passive: true });
    });

    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach((p) => {
        p.hidden = p.id !== tab.getAttribute('aria-controls');
      });
      panels.forEach(gauge);
      if (tab.scrollIntoView) tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (focus) tab.focus();
    };

    /* Capture-phase listener stops Dawn closing the drawer on any button click (D-0357) */
    root.querySelector('[role="tablist"]').addEventListener(
      'click',
      (event) => {
        const tab = event.target.closest('[data-drb-drawer-tab]');
        if (!tab || !tabs.includes(tab)) return;
        event.stopPropagation();
        event.preventDefault();
        select(tab, false);
      },
      true
    );

    root.querySelector('[role="tablist"]').addEventListener('keydown', (event) => {
      const at = tabs.indexOf(document.activeElement);
      if (at < 0) return;

      let next = null;
      if (event.key === 'ArrowRight') next = tabs[(at + 1) % tabs.length];
      if (event.key === 'ArrowLeft') next = tabs[(at - 1 + tabs.length) % tabs.length];
      if (event.key === 'Home') next = tabs[0];
      if (event.key === 'End') next = tabs[tabs.length - 1];
      if (!next) return;

      event.preventDefault();
      select(next, true);
    });

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => panels.forEach(gauge));
      panels.forEach((p) => ro.observe(p));
    }
  });
})();
